module.exports = __webpack_public_path__ + "static/media/insta.7de7e7b0.png";